import AssignedCaseDetail from '../shared/AssignedCaseDetail';

export default function AdminAssignedTicketDetail() {
  return <AssignedCaseDetail basePath="/hcms/admin-assigned-tickets" title="System Admin Ticket" />;
}
